'use client';

import { useState, useEffect } from 'react';
import { BlogPost } from '../../types/blog';
import { useBlogService } from '../../hooks/useBlogService';
import { BlogCard } from './BlogCard';
import styles from './Blog.module.css';

interface BlogOtherPostsProps {
  currentPostId: string;
}

export function BlogOtherPosts({ currentPostId }: BlogOtherPostsProps) {
  const { getPublishedPosts } = useBlogService();
  const [otherPosts, setOtherPosts] = useState<BlogPost[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchOtherPosts = async () => {
      try {
        const result = await getPublishedPosts({ limit: 4, page: 0 });
        if (result?.items) {
          const filtered = result.items.filter(p => p._id !== currentPostId).slice(0, 3);
          setOtherPosts(filtered);
        }
      } catch (error) {
        console.error('Error fetching other posts:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchOtherPosts();
  }, [currentPostId, getPublishedPosts]);

  if (loading) {
    return (
      <div className={styles.otherPostsSection}>
        <h2 className={styles.otherPostsTitle}>Other Posts</h2>
        <div className={styles.otherPostsLoading} />
      </div>
    );
  }

  return (
    <div className={styles.otherPostsSection}>
      <h2 className={styles.otherPostsTitle}>Other Posts</h2>
      {otherPosts.length > 0 ? (
        <div className={styles.otherPostsGrid}>
          {otherPosts.map((otherPost) => (
            <BlogCard key={otherPost._id} post={otherPost} variant="small" />
          ))}
        </div>
      ) : (
        <p className={styles.otherPostsEmpty}>No other posts found.</p>
      )}
    </div>
  );
}
